import { useSetAtom } from "jotai";
import { AppActionSheetProps } from "./AppActionSheets";
import { actionSheetsAtom } from "./actionSheetsAtom";

export function useActionSheet() {
  const setActionSheet = useSetAtom(actionSheetsAtom);

  function createActionSheet<TValue>(params: {
    options: { value: TValue; text: string }[];
    onChange: (value: TValue) => void;
  }) {
    const id = Math.random().toString(36).substring(7);

    const props: AppActionSheetProps<TValue> = {
      isOpen: true,
      onClose: () => removeActionSheet(id),
      ...params,
    };

    setActionSheet((actionSheets) => [...actionSheets, { id, props }]);

    return { id, remove: () => removeActionSheet(id) };
  }

  function removeActionSheet(id: string) {
    setActionSheet((actionSheets) => actionSheets.filter((actionSheet) => actionSheet.id !== id));
  }

  return {
    createActionSheet,
    removeActionSheet,
  };
}
